export default {
  homepage: {
    topDealsTag: "3be5d4f8-5fc6-4ec0-8546-5777fa4c651b",
    topDeals: "Die Topdeals des Tages",
    currentDealsTitle: "Aktuelle Deals",
    currentDealsSubline:
      "Hier findet ihr alle verfügbaren Deals auf einen Blick",
    buttonText: "Zu den Deals",

    tagSection_1_tagImage: "/assets/images/home-mood/destination_switzerland",
    tagSection_1_tagId: "4cad9e96-629b-4c22-a286-3dd772ac68f1",
    tagSection_1_title: "Schweiz Ferien",
    tagSection_1_subline:
      "Gute und preiswerte Angebote für Ferien in der Heimat",

    tagSection_2_tagImage: "/assets/images/home-mood/tag_flexcancel",
    tagSection_2_tagId: "a852992f-ce07-4a80-9b6c-c1b35ee9a036",
    tagSection_2_title: "Flexible Stornierungsbedingungen",
    tagSection_2_subline:
      "Deals mit guten Stornierungs- und Umbuchungsmöglichkeiten",

    tagSection_3_tagImage: "/assets/images/home-mood/destination_spain",
    tagSection_3_tagId: "e98a26ba-819f-4cc9-9767-3393f5e58556",
    tagSection_3_title: "Pauschalreisen",
    tagSection_3_subline:
      "Hier findet Ihr die besten Pauschalreisen mit guten Stornierungsmöglichkeiten für eure nächsten Ferien.",

    promotionSection_link: "https://holidayguru.ch/adventskalender-2020",
    promotionSection_title: "Der grosse Adventskalender",
    promotionSection_subline:
      "Mitmachen und im Advent vier tolle Reisen gewinnen!",

    partnerSection_link: "https://hotels.holidayguru.ch/",
    partnerSection_title: "Hotelsuche",
    partnerSection_subline: "Unterkünfte, wie ihr sie braucht",
    noMoreDealsInfo: "keine weiteren Angebote vorhanden"
  },
  supportPersonImageSrc: "/assets/images/callcenter/lena.jpg",

  magazine: {
    section: {
      link: "https://www.holidayguru.ch/reisemagazin/",
      image: "/assets/images/magazine/ch.jpg"
    }
  },

  raffle: {
    link: "https://www.holidayguru.ch/kreta-osterwettbewerb/"
  },

  partnerList: {
    headline: "Weitere Reisearten",
    subline: "Ferien, wie ihr sie braucht",
    data: [
      {
        label: "Hotels",
        sub: "Die perfekte Unterkunft",
        url: "https://hotels.holidayguru.ch/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_hotels.png"
      },
      {
        label: "Flüge",
        sub: "Günstige Flüge weltweit",
        url: "https://www.holidayguru.ch/flugsuche/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fluege.png"
      },
      {
        label: "Kurzreisen",
        sub: "Kurz mal weg mit Wellness, Events & mehr",
        url: "https://kurzreisen.holidayguru.ch/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kurzreisen.png"
      },
      {
        label: "Last Minute",
        sub: "Last Minute Angebote zum kleinen Preis",
        url: "https://www.holidayguru.ch/last-minute/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png"
      },
      {
        label: "Städtereisen",
        sub: "Citytrips mit Flug & Hotel",
        url: "https://staedtereisen.holidayguru.ch/de-ch",
        image: "/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png"
      },
      {
        label: "Skireisen",
        sub: "Skiferien - preiswert wie nie zuvor",
        url: "https://skiferien.holidayguru.ch/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_skireisen.png"
      },
      {
        label: "Mietwagen",
        sub: "Preiswerte Mietwagen im Vergleich",
        url: "https://www.holidayguru.ch/mietwagen/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png"
      },
      {
        label: "Pauschalreisen",
        sub: "Reisen mit allem was dazu gehört",
        url: "https://booking.holidayguru.ch/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png"
      },
      {
        label: "Reiseanfrage",
        sub: "Stellt jetzt eure individuelle Reiseanfrage",
        url: "https://www.holidayguru.ch/individuelle-reiseanfrage/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_reiseanfragen.png"
      }
    ]
  },

  linkList: [
    {
      label: "Beliebte Ferienziele",
      links: [
        {
          label: "Mallorca Ferien",
          url: "https://www.holidayguru.ch/ferienziele/mallorca-ferien/"
        },
        {
          label: "Griechenland Ferien",
          url: "https://www.holidayguru.ch/ferienziele/griechenland-ferien/"
        },
        {
          label: "Zypern Ferien",
          url: "https://www.holidayguru.ch/ferienziele/zypern-ferien/"
        },
        {
          label: "Italien Ferien",
          url: "https://www.holidayguru.ch/ferienziele/italien-ferien/"
        },
        {
          label: "Spanien Ferien",
          url: "https://www.holidayguru.ch/ferienziele/spanien-ferien/"
        },
        {
          label: "Kanaren Ferien",
          url: "https://www.holidayguru.ch/ferienziele/kanaren-ferien/"
        },
        {
          label: "Schweiz Ferien",
          url: "https://www.holidayguru.ch/schweizliebe/"
        }
      ]
    },
    {
      label: "Ferienziele weltweit",
      links: [
        {
          label: "Ägypten Ferien",
          url: "https://www.holidayguru.ch/ferienziele/aegypten-ferien/"
        },
        {
          label: "Dubai Ferien",
          url: "https://www.holidayguru.ch/ferienziele/dubai-ferien/"
        },
        {
          label: "Türkei Ferien",
          url: "https://www.holidayguru.ch/ferienziele/tuerkei-ferien/"
        },
        {
          label: "Thailand Ferien",
          url: "https://www.holidayguru.ch/tag/thailand/"
        },
        {
          label: "DomRep Ferien",
          url: "https://www.holidayguru.ch/tag/dominikanische-republik/"
        },
        {
          label: "Malediven Ferien",
          url: "https://www.holidayguru.ch/tag/malediven/"
        },
        {
          label: "Hurghada Ferien",
          url: "https://www.holidayguru.ch/tag/hurghada/"
        }
      ]
    },
    {
      label: "Reisearten",
      links: [
        {
          label: "Pauschalreisen",
          url: "https://www.holidayguru.ch/pauschalreisen/"
        },
        {
          label: "All Inclusive",
          url: "https://www.holidayguru.ch/tag/all-inclusive/"
        },
        {
          label: "Städtetrip",
          url: "https://www.holidayguru.ch/tag/staedtetrip/"
        },
        {
          label: "Luxusferien",
          url: "https://www.holidayguru.ch/tag/luxus/"
        },
        {
          label: "Kurztrip",
          url: "https://www.holidayguru.ch/tag/kurztrip/"
        },
        {
          label: "Familienferien",
          url: "https://www.holidayguru.ch/tag/familienferien/"
        },
        {
          label: "Singlereisen",
          url: "https://www.holidayguru.ch/tag/singlereise/"
        }
      ]
    },
    {
      label: "Wellnessferien",
      links: [
        {
          label: "Wellness",
          url: "https://www.holidayguru.ch/wellnessferien/"
        },
        {
          label: "Wellness im Schwarzwald",
          url: "https://www.holidayguru.ch/tag/wellness-im-schwarzwald/"
        },
        {
          label: "Wellness in Bayern",
          url: "https://www.holidayguru.ch/tag/wellness-in-bayern/"
        },
        {
          label: "Wellness in Tirol",
          url: "https://www.holidayguru.ch/tag/wellness-in-tirol/"
        },
        {
          label: "Wellnesshotel",
          url: "https://www.holidayguru.ch/tag/wellnesshotel/"
        },
        {
          label: "Thermenangebote",
          url: "https://www.holidayguru.ch/tag/thermen-angebote/"
        }
      ]
    },
    {
      label: "Städtereisen",
      links: [
        {
          label: "Städtereisen",
          url: "https://www.holidayguru.ch/tag/staedtereise/"
        },
        {
          label: "Städtereise London",
          url: "https://www.holidayguru.ch/tag/london/"
        },
        {
          label: "Städtereise New York",
          url: "https://www.holidayguru.ch/tag/new-york/"
        },
        {
          label: "Städtereise Paris",
          url: "https://www.holidayguru.ch/tag/paris/"
        },
        {
          label: "Städtereise Wien",
          url: "https://www.holidayguru.ch/tag/wien/"
        },
        {
          label: "Städtereise Amsterdam",
          url: "https://www.holidayguru.ch/tag/amsterdam/"
        },
        {
          label: "Städtereise Berlin",
          url: "https://www.holidayguru.ch/tag/berlin/"
        }
      ]
    },
    {
      label: "Last Minute",
      links: [
        {
          label: "Last Minute",
          url: "https://www.holidayguru.ch/last-minute/"
        },
        {
          label: "Last Minute Ägypten",
          url: "https://www.holidayguru.ch/last-minute-aegypten/"
        },
        {
          label: "Last Minute Dubai",
          url: "https://www.holidayguru.ch/last-minute-dubai/"
        },
        {
          label: "Last Minute Griechenland",
          url: "https://www.holidayguru.ch/last-minute-griechenland/"
        },
        {
          label: "Last Minute Mallorca",
          url: "https://www.holidayguru.ch/last-minute-mallorca/"
        },
        {
          label: "Last Minute Türkei",
          url: "https://www.holidayguru.ch/last-minute-tuerkei/"
        }
      ]
    },
    {
      label: "Specials",
      links: [
        {
          label: "Flexibel stornierbare Angebote",
          url: "https://www.holidayguru.ch/tag/flexible-stornierungsbedingungen/"
        },
        {
          label: "Brückentage Angebote",
          url: "https://www.holidayguru.ch/tag/brueckentage/"
        },
        {
          label: "Ferien unter 100 CHF",
          url: "https://www.holidayguru.ch/tag/ferien-unter-100-chf/"
        },
        {
          label: "Skiferien",
          url: "https://www.holidayguru.ch/tag/skiferien/"
        },
        {
          label: "Hotelgutscheine",
          url: "https://www.holidayguru.ch/tag/hotelgutschein/"
        },
        {
          label: "Freizeitpark Angebote",
          url: "https://www.holidayguru.ch/tag/freizeitpark-deals/"
        },
        {
          label: "Aktivitäten & mehr",
          url: "https://www.holidayguru.ch/tag/aktivitaeten-mehr/"
        }
      ]
    },
    {
      label: "Informationen",
      links: [
        {
          label: "Reisemagazin",
          url: "https://www.holidayguru.ch/reisemagazin/"
        },
        {
          label: "Reisekalender",
          url: "https://www.holidayguru.ch/reisekalender/"
        },
        {
          label: "Beste Reisezeit",
          url: "https://www.holidayguru.ch/reisekalender/beste-reisezeit/"
        },
        {
          label: "Freizeitaktivitäten",
          url: "https://www.holidayguru.ch/freizeitaktivitaeten/"
        },
        {
          label: "Lexikon",
          url: "https://www.holidayguru.ch/lexikon/"
        }
      ]
    }
  ],

  footer: {
    corporate: {
      label: "Unternehmen",
      data: [
        {
          label: "Über Holidayguru",
          url: "https://www.holidayguru.ch/ueber-uns/"
        },
        {
          label: "Jobs",
          url: "https://www.urlaubsguru.de/jobs/"
        },
        {
          label: "Werbung",
          url: "https://www.holidayguru.ch/werbung-und-kooperationen/"
        },
        {
          label: "Presse",
          url: "https://www.urlaubsguru.de/presse/"
        }
      ]
    },
    informations: {
      label: "Informationen",
      data: [
        {
          label: "Corona Infos",
          url: "https://www.holidayguru.ch/reisemagazin/coronavirus-faq/"
        },
        {
          label: "Buchen beim Holidayguru",
          url: "https://www.holidayguru.ch/suchen-buchen-holidayguru/"
        },
        {
          label: "Dein Feedback an Uns",
          url: "https://www.holidayguru.ch/holidayguru-feedback/"
        },
        {
          label: "Reisemagazin",
          url: "https://www.holidayguru.ch/reisemagazin/"
        }
      ]
    },
    buttons: [
      {
        label: "Datenschutz",
        url: "https://www.holidayguru.ch/datenschutzerklaerung/"
      },
      {
        label: "Sitemap",
        url: "https://www.holidayguru.ch/sitemap/"
      },
      {
        label: "Schlagworte",
        url: "https://www.holidayguru.ch/tag/"
      },
      {
        label: "Impressum / Rechtliche Hinweise",
        url: "https://www.holidayguru.ch/impressum/"
      }
    ],
    social: {
      label: "Folgt uns auf",
      data: [
        {
          label: "Facebook",
          icon: "facebook",
          url: "https://www.facebook.com/urlaubsguru.ch/"
        },
        {
          label: "Instagram",
          icon: "instagram",
          url: "https://www.instagram.com/Holidayguru_ch/"
        }
      ]
    },
    newsletter: {
      label: "Meldet euch für den Newsletter an",
      button: "Zum Newsletter",
      url: "https://www.holidayguru.ch/messenger/#newsletter"
    },
    app: {
      label: "Ladet euch die App herunter",
      apple:
        "https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087",
      android: "https://play.google.com/store/apps/details"
    }
  },
  skiSearchControls: {
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: "any"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "1-2 Nächte",
        value: "1,2"
      },
      {
        name: "2-5 Nächte",
        value: "2,5"
      },
      {
        name: "5-9 Nächte",
        value: "5,9"
      },
      {
        name: "9-11 Nächte",
        value: "9,11"
      },
      {
        name: "1 Nacht",
        value: "1,1"
      },
      {
        name: "2 Nächte",
        value: "2,2"
      },
      {
        name: "3 Nächte",
        value: "3,3"
      },
      {
        name: "4 Nächte",
        value: "4,4"
      },
      {
        name: "5 Nächte",
        value: "5,5"
      },
      {
        name: "6 Nächte",
        value: "6,6"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "8 Nächte",
        value: "8,8"
      },
      {
        name: "9 Nächte",
        value: "9,9"
      },
      {
        name: "10 Nächte",
        value: "10,10"
      },
      {
        name: "11 Nächte",
        value: "11,11"
      }
    ]
  },

  ibeSearchControls: {
    dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: ""
      },
      {
        name: "1 - 4 Tage",
        value: "1,4"
      },
      {
        name: "5 - 8 Tage",
        value: "5,8"
      },
      {
        name: "9 - 12 Tage",
        value: "9,12"
      },
      {
        name: "10  Tage",
        value: "10"
      },
      {
        name: "1 Wochenende",
        value: "2"
      },
      {
        name: "1 Woche",
        value: "7"
      },
      {
        name: "2 Wochen",
        value: "14"
      }
    ],
    childAgeOptions: [
      { label: "< 2 Jahre", value: 1 },
      { label: "2 Jahre", value: 2 },
      { label: "3 Jahre", value: 3 },
      { label: "4 Jahre", value: 4 },
      { label: "5 Jahre", value: 5 },
      { label: "6 Jahre", value: 6 },
      { label: "7 Jahre", value: 7 },
      { label: "8 Jahre", value: 8 },
      { label: "9 Jahre", value: 9 },
      { label: "10 Jahre", value: 10 },
      { label: "11 Jahre", value: 11 },
      { label: "12 Jahre", value: 12 },
      { label: "13 Jahre", value: 13 },
      { label: "14 Jahre", value: 14 },
      { label: "15 Jahre", value: 15 },
      { label: "16 Jahre", value: 16 },
      { label: "17 Jahre", value: 17 }
    ]
  },

  jsonLD: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Holidayguru",
    url: "https://www.holidayguru.ch/",
    logo: "https://www.holidayguru.ch/wp-content/uploads/2016/04/holidayguru_277_60x2-1.png",
    sameAs: [
      "https://www.facebook.com/urlaubsguru.ch/",
      "https://www.instagram.com/Holidayguru_ch/"
    ]
  },
  searchCustomLinks: [
    {
      label: "Kurzreisen",
      url: "https://kurzreisen.holidayguru.ch/getaways/",
      icon: "deck-chair-sun"
    }
  ],
  privacyManagerModalId: "547872",
  destination_category_destination: "Regionen",
  destination_category_region: "Regionen",
  destination_category_accommodation: "Hotels",
  destination_category_city: "Städte",
  destination_category_poi: "Sehenswürdigkeiten",
  destination_category_point_of_interest: "Sehenswürdigkeiten",
  destination_category_multi_city_vicinity: "Gebiete",
  destination_category_province_state: "Regionen",
  destination_category_neighborhood: "Umgebungen",
  destination_category_airport: "Flughäfen",
  destination_category_train_station: "Bahnstationen",
  destination_category_metro_station: "Metrostationen",
  destination_category_continent: "Kontinente",
  destination_category_country: "Länder",
  destination_category_high_level_region: "Gebiete",

  newsletter: {
    title: "Dein Urlaubsguru-Newsletter",
    info: "Du suchst nach <strong>hilfreichen Reiseempfehlungen und Top Deals?</strong> Dann melde dich für den exklusiven Urlaubsguru Newsletter an. <br /> <br />Das erwartet dich:",
    listItem1: "handverlesene Angebote von den Urlaubsguru-Reiseexperten",
    listItem2: "Deals mit unschlagbarem Preisleistungsverhältnis",
    listItem3: "Inspiration und hilfreiche Tipps für deine nächste Reise",
    button: "Newsletter anmelden"
  },
  amadeusPackageTourSearch: {
    infoTextSingleRoom: "Alle Personen werden in einem Zimmer untergebracht. Falls ihr eine andere Zimmeraufteilung wünscht, ruft uns an:"
  }
}
